import CryptoJS from 'crypto-js';

export const encryptData = (data) => {
    const secretKey = 'diHdcFp12-35GFCndjf-dsj$';
    return CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
};

export const decryptData = (encryptedData) => {
    const secretKey = 'diHdcFp12-35GFCndjf-dsj$';
    try {
        const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
        const decryptedText = bytes.toString(CryptoJS.enc.Utf8);
        
        if (decryptedText) {
            return JSON.parse(decryptedText);
        } else {
            console.error('Decryption produced an empty result.');
            return null;
        }
    } catch (e) {
        console.error('Decryption or JSON parsing failed:', e);
        return null;
    }
};